<template>
  <div class="Detailscontent">
      <div class="title">
          <Star :label="label" :occurant="occurant" styleStar="styleStar" :display="display"/>
        </div>
      <div class="body" v-html="text"></div>
  </div>
</template>

<script>
import Star from './Star'
export default {
    props:{
        label:{
            type:String
        },
        occurant:{
            type:Number
        },
        text:{
            type:String
        },
        display: {
            type: Boolean
        }
    },
components:{
    Star
}
}
</script>

<style scoped lang="scss">
.Detailscontent{
    display: inline;
    width: 100%;
    color:#4E4E4E;
    .title{
        display: flex;
        width: 100%;
        margin-bottom: 13px;
        .star {
            table {
                width: 40% !important;
            }
        }
    }
    .body{
        font-size:16px;
        margin: 25px;
        line-height: 1.5em;
    }
}
</style>